import { api } from '@/apis';
import { log } from '@/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useDeleteRetention() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (identifier) => {
      if (identifier) {
        log('Delete', 'Data Retention', { identifier });

        return api.delete(`telematicsBoxRetentions/${identifier}`).json();
      }
    },
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ['retentions'] }),
  });
}
